import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import FadeIn from "./FadeIn";

const AccordionItem = ({ question, answer, isOpen, onToggle }) => (
  <div className="ku-glass rounded-ku-lg overflow-hidden border border-ku-soft/50">
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left min-h-[56px]"
      aria-expanded={isOpen}
    >
      <span className="font-display font-semibold text-ku-royal pr-4">{question}</span>
      <span className="flex-shrink-0 w-10 h-10 rounded-full bg-ku-soft flex items-center justify-center text-ku-violet">
        {isOpen ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
      </span>
    </button>
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="overflow-hidden"
        >
          <p className="px-5 md:px-6 pb-5 md:pb-6 text-gray-600 font-body leading-relaxed border-t border-ku-soft/50 pt-4">
            {answer}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

const AccordionFAQ = ({ items, title, subtitle }) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="ku-section bg-white">
      <div className="ku-container max-w-3xl">
        <FadeIn>
          {title && (
            <h2 className="ku-heading-lg text-center mb-3">{title}</h2>
          )}
          {subtitle && (
            <p className="text-center text-gray-600 font-body text-lg mb-10">{subtitle}</p>
          )}
        </FadeIn>
        <div className="space-y-4">
          {items.map((item, i) => (
            <FadeIn key={i} delay={i * 0.05}>
              <AccordionItem
                question={item.question}
                answer={item.answer}
                isOpen={openIndex === i}
                onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
              />
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AccordionFAQ;
